<template lang='pug'>
    #branch-office-button( class='d-flex' )
        v-btn( v-bind='buttonProps' @click='dialog ^= 1' ) {{ value | name }} &nbsp;
            v-icon store
        v-dialog( v-bind='dialogProps' v-model='dialog' )
            r-form( 
                class='white'
                ref='form'
                loadingText='cambiando sucursal...'
                resetText='cancelar'
                submitText='cambiar'
                title='Cambiar sucursal'
                v-bind='formProps' 
                v-model='value'
                @reset='dialog ^= 1'
                @submit='submit' 
            )
</template>

<script>
    //
    import { RForm } from '../next'
    //
    export default {
        components: {
            RForm,
        },
        computed: {

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            formProps() {
                return {
                    fields: [
                        {
                            name: 'g_branch_office_name',
                            type: 'text-field',
                            flex: {
                                xs12: true,
                            },
                            props: {
                                label: 'Actual',
                                readonly: true,
                            },
                        },
                        {
                            name: 'g_branch_office_id',
                            type: 'select',
                            flex: {
                                xs12: true,
                            },
                            props: {
                                items: this.items,
                                itemText: 'name',
                                itemValue: 'id',
                                label: 'Deseada',
                                noDataText: 'Sin sucursales',
                            },
                        },
                    ],
                    loading: this.busy,
                }
            },
        },
        data() {
            return {
                dialog: false,
            }
        },
        filters: {

            /**
             * { lambda_description }
             *
             * @param      {<type>}  value   The value
             * @return     {<type>}  { description_of_the_return_value }
             */
            name: value => value.g_branch_office_name || '-',
        },
        methods: {

            /**
             * { function_description }
             *
             * @param      {<type>}  event   The event
             * @return     {<type>}  { description_of_the_return_value }
             */
            submit(event) {
                return this.$emit('submit', event)
            },
        },
        props: {

            /**
             * { item_description }
             */
            busy: {
                type: Boolean,
                default: false,
            },

            /**
             * { item_description }
             */
            buttonProps: {
                type: Object,
                default: () => ({
                    color: 'info',
                }),
            },

            /**
             * { item_description }
             */
            dialogProps: {
                type: Object,
                default: () => ({
                    width: 720,
                })
            },

            /**
             * { item_description }
             */
            items: {
                type: Array,
                default: () => [],
            },

            /**
             * { item_description }
             */
            value: {
                type: Object,
                default: () => ({}),
            },
        },
    }
</script>
